import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { Region, State } from "@/gql/graphql";
import { useTranslations } from "use-intl";

export function StateInput({
  region,
  ...props
}: Omit<SelectInputProps<any>, "options"> & {
  region?: Region | null;
}) {
  const t = useTranslations("city");

  const sections = [
    {
      label: "Australia",
      region: Region.Au,
      states: [
        State.AuAct,
        State.AuNsw,
        State.AuNt,
        State.AuQld,
        State.AuSa,
        State.AuTas,
        State.AuVic,
        State.AuWa,
      ],
    },
    {
      label: "United States",
      region: Region.Us,
      states: [
        State.UsAk,
        State.UsAl,
        State.UsAr,
        State.UsAz,
        State.UsCa,
        State.UsCo,
        State.UsCt,
        State.UsDe,
        State.UsFl,
        State.UsGa,
        State.UsHi,
        State.UsIa,
        State.UsId,
        State.UsIl,
        State.UsIn,
        State.UsKs,
        State.UsKy,
        State.UsLa,
        State.UsMa,
        State.UsMd,
        State.UsMe,
        State.UsMi,
        State.UsMn,
        State.UsMo,
        State.UsMt,
        State.UsNc,
        State.UsNd,
        State.UsNe,
        State.UsNh,
        State.UsNj,
        State.UsNm,
        State.UsNv,
        State.UsNy,
        State.UsOh,
        State.UsOk,
        State.UsOr,
        State.UsPa,
        State.UsRi,
        State.UsSc,
        State.UsSd,
        State.UsTn,
        State.UsTx,
        State.UsUt,
        State.UsVa,
        State.UsVt,
        State.UsWa,
        State.UsWi,
        State.UsWv,
        State.UsWy,
        State.UsMs,
        State.UsDc,
      ],
    },
    {
      label: "Canada",
      region: Region.Ca,
      states: [
        State.CaAb,
        State.CaBc,
        State.CaMb,
        State.CaNb,
        State.CaNl,
        State.CaNs,
        State.CaNt,
        State.CaNu,
        State.CaOn,
        State.CaPe,
        State.CaQc,
        State.CaSk,
        State.CaYt,
      ],
    },
    {
      label: "New Zealand",
      region: Region.Nz,
      states: [
        State.NzAuk,
        State.NzBop,
        State.NzCan,
        State.NzGis,
        State.NzHkb,
        State.NzMbh,
        State.NzMwt,
        State.NzNtl,
        State.NzStl,
        State.NzTas,
        State.NzTki,
        State.NzWgn,
        State.NzWko,
        State.NzWtc,
        State.NzNsn,
        State.NzOta,
      ],
    },
    {
      label: "Japan",
      region: Region.Jp,
      states: [
        State.Jp_01,
        State.Jp_02,
        State.Jp_03,
        State.Jp_04,
        State.Jp_05,
        State.Jp_06,
        State.Jp_07,
        State.Jp_08,
        State.Jp_09,
        State.Jp_10,
        State.Jp_11,
        State.Jp_12,
        State.Jp_13,
        State.Jp_14,
        State.Jp_15,
        State.Jp_16,
        State.Jp_17,
        State.Jp_18,
        State.Jp_19,
        State.Jp_20,
        State.Jp_21,
        State.Jp_22,
        State.Jp_23,
        State.Jp_24,
        State.Jp_25,
        State.Jp_26,
        State.Jp_27,
        State.Jp_28,
        State.Jp_29,
        State.Jp_30,
        State.Jp_31,
        State.Jp_32,
        State.Jp_33,
        State.Jp_34,
        State.Jp_35,
        State.Jp_36,
        State.Jp_37,
        State.Jp_38,
        State.Jp_39,
        State.Jp_40,
        State.Jp_41,
        State.Jp_42,
        State.Jp_43,
        State.Jp_44,
        State.Jp_45,
        State.Jp_46,
        State.Jp_47,
      ],
    },
    {
      label: "Taiwan",
      region: Region.Tw,
      states: [
        State.TwTpe,
        State.TwNwt,
        State.TwTao,
        State.TwTxg,
        State.TwTnn,
        State.TwKhh,
      ],
    },
    {
      label: "Europe",
      region: Region.Eu,
      states: [
        State.Al,
        State.Am,
        State.At,
        State.Bg,
        State.Ba,
        State.Be,
        State.By,
        State.Ch,
        State.Cy,
        State.Cz,
        State.De,
        State.Dk,
        State.Ee,
        State.Es,
        State.Fi,
        State.Fr,
        State.Gb,
        State.Gr,
        State.Hr,
        State.Hu,
        State.Ie,
        State.It,
        State.Lt,
        State.Lv,
        State.Me,
        State.Mk,
        State.Nl,
        State.No,
        State.Pl,
        State.Pt,
        State.Ro,
        State.Rs,
        State.Se,
        State.Si,
        State.Sk,
        State.Xk,
      ],
    },
    {
      label: "South Africa",
      region: Region.Sacu,
      states: [
        State.Ls,
        State.ZaEc,
        State.ZaFs,
        State.ZaGp,
        State.ZaKzn,
        State.ZaLp,
        State.ZaMp,
        State.ZaNc,
        State.ZaNw,
        State.ZaWc,
      ],
    },
    {
      label: "Botswana",
      region: Region.Sacu,
      states: [
        State.BwCe,
        State.BwCh,
        State.BwGh,
        State.BwKg,
        State.BwKl,
        State.BwKw,
        State.BwNe,
        State.BwNw,
        State.BwSe,
        State.BwSo,
      ],
    },
    {
      label: "Lesotho",
      region: Region.Sacu,
      states: [State.Ls],
    },
    {
      label: "Swaziland",
      region: Region.Sacu,
      states: [State.SzHh, State.SzLu, State.SzMa, State.SzSh],
    },
    {
      label: "Namibia",
      region: Region.Sacu,
      states: [
        State.NaCa,
        State.NaEr,
        State.NaHa,
        State.NaKa,
        State.NaKe,
        State.NaKh,
        State.NaKu,
        State.NaKw,
        State.NaOd,
        State.NaOh,
        State.NaOn,
        State.NaOs,
        State.NaOt,
        State.NaOw,
      ],
    },
    {
      label: "Pacific Islands",
      region: Region.Pi,
      states: [State.Fj, State.Id, State.Nc, State.Pg, State.Sb, State.Vu],
    },
    {
      label: "Argentina",
      region: Region.Sa,
      states: [
        State.ArBa,
        State.ArCf,
        State.ArCo,
        State.ArMz,
        State.ArSf,
        State.ArTu,
      ],
    },
    {
      label: "Brasil",
      region: Region.Sa,
      states: [
        State.BrSp,
        State.BrRj,
        State.BrMg,
        State.BrBa,
        State.BrPr,
        State.BrRs,
      ],
    },
    {
      label: "Chile",
      region: Region.Sa,
      states: [
        State.ClAr,
        State.ClBi,
        State.ClCo,
        State.ClLl,
        State.ClRm,
        State.ClVs,
        State.ClAn,
        State.ClMa,
      ],
    },
    {
      label: "Mexico",
      region: Region.Mx,
      states: [
        State.MxCmx,
        State.MxJal,
        State.MxNle,
        State.MxQue,
        State.MxBcn,
        State.MxYuc,
      ],
    },
    {
      label: "South Korea",
      region: Region.Kr,
      states: [
        State.KrSeo,
        State.KrPus,
        State.KrInc,
        State.KrDag,
        State.KrGgi,
        State.KrJej,
      ],
    },
    {
      label: "UAE",
      region: Region.Me,
      states: [State.AeDu, State.AeAd],
    },
    {
      label: "Saudi Arabia",
      region: Region.Me,
      states: [State.SaRy, State.SaMk],
    },
    {
      label: "Qatar",
      region: Region.Me,
      states: [State.Qa],
    },
    {
      label: "Kuwait",
      region: Region.Me,
      states: [State.Kw],
    },
    {
      label: "Oman",
      region: Region.Me,
      states: [State.Om],
    },
  ];

  const options = sections
    .filter((section) => {
      if (region) {
        return section.region === region;
      }
      return true;
    })
    .map((section) => ({
      label: section.label,
      options: section.states
        .map((state) => ({
          value: state,
          label: t(`state.${state}`) as string,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    }));

  return (
    <SelectInput
      options={options}
      filter={(value, search) => {
        const label: string = t(`state.${value as State}`);
        return label.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
      }}
      {...props}
    />
  );
}
